<template>
    <div class="modal-body h4">
        <div class="row">
            <div class="col-md-5 col-xs-5"></div>
            <div class="col-md-2 col-xs-2">Fácil</div>
            <!--div class="col-md-2 col-xs-2"></div-->
            <div class="col-md-2 col-xs-2">Difícil</div>
            <div class="col-md-2 col-xs-2"></div>
        </div>
        <div class="row">
            <div class="col-md-5 text-left col-xs-5" style="padding: 10px;">Cadastro</div>
            <div class="col-md-2 col-xs-2" style="padding: 10px;" v-for="rate in ratingsValues">
                <input name="registerRate" :value="rate" type="radio" v-model="registerRate">
            </div>
        </div>
        <div class="row">
            <div class="col-md-5 text-left col-xs-5" style="padding: 10px">Interface</div>
            <div class="col-md-2 col-xs-2" style="padding: 10px;" v-for="rate in ratingsValues">
                <input name="interfaceRate" :value="rate" type="radio" v-model="interfaceRate">
            </div>
        </div><!--  -->
        <div class="row" v-if="showPayment">
            <div class="col-md-5 text-left col-xs-5" style="padding: 10px">Pagamento</div>
            <div class="col-md-2 col-xs-2" style="padding: 10px;" v-for="rate in ratingsValues">
                <input name="paymentRate" :value="rate" type="radio" v-model="paymentRate">
            </div>
        </div>
        <div class="row">
            <div class="col-md-5 text-left col-xs-5" style="padding: 10px">Suporte</div>
            <div class="col-md-2 col-xs-2" style="padding: 10px;" v-for="rate in ratingsValues">
                <input name="supportRate" :value="rate" type="radio" v-model="supportRate">
            </div>
        </div>
        <div class="row" v-if="registerRate >= 3 || interfaceRate >= 3 || paymentRate >= 3 || supportRate >= 3">
            <div class="col-md-5 text-left" style="padding: 10px">Sugestões</div>
            <div class="col-md-11">
                <textarea class="form-control" v-model="suggestionText"></textarea>
            </div>
        </div>

        <div class="modal-footer">
            <button onclick="closeRatingModal()" class="btn btn-md btn-gray">Fechar</button>

            <button class="btn btn-lg btn-primary" @click="sendRating()">Enviar</button>
        </div>
        <div class="row">
            <div class="col-md-12" v-if="errorReturned">
                <div class="alert alert-danger" role="alert">
                    <strong>Erro!</strong> {{ errorReturned }}
                </div>
            </div>
            <div class="col-md-12" v-for="error in errors">
                <div class="alert alert-danger" role="alert">
                    {{ error[0] }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                registerRate:null,
                interfaceRate:null,
                paymentRate:null,
                supportRate:null,
                suggestionText:null,
                errorReturned:null,
                errors:[],
                showPayment:false,
            };
        },
        props:['uri', 'user_role'],
        filters: {

        },
        mounted() {
            if(this.user_role == 'expert' && this.uri.match(/demandas/g)){
                this.showPayment = true;
            }
        },
        computed: {
            ratingsValues(){
                return [1,2];
            }
        },
        methods: {
            sendRating(){
                this.clearErrors();
                axios.post('/rating', {
                    supportRate:this.supportRate,
                    registerRate:this.registerRate,
                    interfaceRate:this.interfaceRate,
                    suggestionText:this.suggestionText,
                    paymentRate:this.paymentRate,
                    uri:this.uri,
                })
                .then((result)=> {
                    if(result.data.success){
                        closeRatingModal();
                        openThanksRatingModal();
                    } else {
                        this.errorReturned = result.data.error;
                    }
                })
                .catch((result) => {
                    this.errors = result.response.data.errors;
                });
            },
            clearErrors(){
                this.errors = [];
                this.errorReturned = null;
            }
        }
    }
</script>